<elm-icon *ngIf="icon" [icon]="icon" class="elm-size-icon-empty-state elm-color-icon-standard elm-spacing-l"></elm-icon>
<h1 *ngIf="title" class="elm-display-2 elm-fg-5 elm-spacing-xs">{{ title }}</h1>
<p *ngIf="message" class="elm-body-1 elm-fg-5 elm-no-margin">{{ message }}</p>
